export default __webpack_public_path__ + "static/lihook-mobile-33f2183d71196841a06e0ed165141a3d.png";